import { bool, func, instanceOf, string } from 'prop-types'
import { ReactNode } from 'react'
import { Divider, Header, List } from 'semantic-ui-react'
import Linechart from './Linechart'

interface FluxLiveChartProps {
  data: any[]
  xaxis?: object
  yaxis?: object
  downloadFilename?: string
  hasActiveSession?: boolean
  uiRevisionKey?: string
  statusIndicators?: ReactNode
}

const FluxLiveChart = ({
  data, xaxis, yaxis, downloadFilename, hasActiveSession, uiRevisionKey, statusIndicators,
}: FluxLiveChartProps) => {
  return (
    <div>
      <Linechart
        data={data}
        xaxis={xaxis}
        yaxis={yaxis}
        downloadFilename={downloadFilename}
        hasActiveSession={hasActiveSession}
        uiRevisionKey={uiRevisionKey}
        statusIndicators={statusIndicators}
      />
      <Divider />

      <div style={{ textAlign: 'justify' }}>
        <div style={{ marginBottom: '1em' }}>
          The live plot displays the real-time solar radio flux recorded by the antenna system, averaged over
          one-second intervals. It shows simultaneous flux measurements in two frequency bands:
          F10.7&nbsp;(≈&nbsp;2.8&nbsp;GHz) and F30&nbsp;(≈&nbsp;1&nbsp;GHz).
        </div>

        <Header as='h3' style={{ marginTop: '0.5em' }}>
          Important notes for live charts:
        </Header>

        <List bulleted>
          <List.Item>
            Flux values are expressed in solar flux units (SFU), where&nbsp; 1&nbsp;SFU&nbsp;=&nbsp;10
            <sup>−22</sup>&nbsp;W&nbsp;m<sup>−2</sup>&nbsp;Hz<sup>−1</sup>&nbsp;(SI units).
          </List.Item>

          <List.Item>
            Every hour, calibration using the noise diode is performed and is not shown on the plot. The short gap in
            the real-time data will be visible.
          </List.Item>
        </List>
      </div>
    </div>
  )
}

FluxLiveChart.propTypes = {
  data: instanceOf(Array),
  setData: func,
  xaxis: instanceOf(Object),
  yaxis: instanceOf(Object),
  downloadFilename: string,
  hasActiveSession: bool,
  uiRevisionKey: string,
  statusIndicators: instanceOf(Object),
}

export default FluxLiveChart
